import React from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import { ReactComponent as PlusIcon } from "assets/icons/plus-large.svg";
import { ReactComponent as ShareIcon } from "assets/icons/share.svg";
import { ReactComponent as PrinterIcon } from "assets/icons/printer.svg";
import { RoundButton, RegularButton } from "components/Button";
import Page from "components/Page/Page";
import { useActiveOrg } from "context/ActiveOrgContext";
import UpdateCustomerForm from "./components/UpdateCustomerForm";
import DetailSelector from "./components/DetailSelector";

const CustomerDetails = () => {
  const { id, orgId: orgIdParam } = useParams();
  const { organisations, setActiveOrg } = useActiveOrg();

  React.useEffect(() => {
    if (!orgIdParam) return;
    const n = Number(orgIdParam);
    if (!Number.isFinite(n) || n <= 0) return;
    const o = organisations.find((x) => x.orgId === n);
    if (o) setActiveOrg(o.orgId, o.orgName);
  }, [orgIdParam, organisations, setActiveOrg]);

  return (
    <Page>
      <Card
        title="View Customer Details"
        subTitle={id ? `Client id: ${id}` : "Following are the details"}
      >
        <div className="flex flex-wrap items-center justify-end gap-4 sm:mr-10">
          <RoundButton Icon={PlusIcon} />
          <RoundButton Icon={ShareIcon} />
          <RoundButton Icon={PrinterIcon} />
          <RegularButton color="Secondary" onClick={() => undefined}>
            <span>QUICK BILL</span>
          </RegularButton>
        </div>
        <UpdateCustomerForm />
        <DetailSelector />
      </Card>
    </Page>
  );
};

export default CustomerDetails;
